import {useIntl} from 'react-intl'
import EarnedPoints from './EarnedPoints'
import RedeemedPoints from './RedeemedPoints'
import {dataToSeries} from '../../utility'
import {currency, digit} from 'src/feature/bite/helpers/currency'

export default function AverageAnalyticsSub({
  point,
}: {
  point?: {
    memberWithPointsCount: number
    totalPointBalance: number
    worthOfTotalPointBalance: number
    totalPointsEarned: number
    totalPointsSpent: number
    earnedPoints: number
    redeemedPoints: number
    earnedPointsChartData: {date: string; value: number}[]
    redeemedPointsChartData: {date: string; value: number}[]
  }
}) {
  const intl = useIntl()

  return (
    <div className='d-flex justify-content-between gap-6'>
      <div
        className='card p-3 min-w-500px d-flex flex-column justify-content-between p-10 fs-4 text-white'
        style={{backgroundColor: '#754F8F'}}
      >
        <div className='d-flex justify-content-between'>
          <span className=''>{intl.formatMessage({id: 'ANALYTICS.MEMBER_WITH_POINTS'})}</span>
          <span>{digit(point?.memberWithPointsCount || 0)}</span>
        </div>
        <div className='separator my-3'></div>
        <div className='d-flex justify-content-between'>
          <span className='fw-bold'>
            {intl.formatMessage({id: 'ANALYTICS.TOTAL_POINT_BALANCE'})}
          </span>
          <span className='fw-bold'>{digit(point?.totalPointBalance || 0)}</span>
        </div>
        <div className='d-flex justify-content-between'>
          <span className='fw-bold'>
            {intl.formatMessage({id: 'ANALYTICS.WORTH_OF_TOTAL_POINT_BALANCE'})}
          </span>
          <span className='fw-bold'>{currency(point?.worthOfTotalPointBalance || 0)}</span>
        </div>
        <div className='separator my-3'></div>
        <div className='d-flex justify-content-between'>
          <span>{intl.formatMessage({id: 'ANALYTICS.TOTAL_POINTS_EARNED'})}</span>
          <span>{digit(point?.totalPointsEarned || 0)}</span>
        </div>
        <div className='d-flex justify-content-between'>
          <span>{intl.formatMessage({id: 'ANALYTICS.TOTAL_POINTS_SPENT'})}</span>
          <span>{digit(point?.totalPointsSpent || 0)}</span>
        </div>
      </div>
      <div className='card px-5 min-w-400px w-100'>
        <EarnedPoints
          total={digit(point?.earnedPoints || 0)}
          data={dataToSeries(
            intl.formatMessage({id: 'ANALYTICS.EARNED_POINTS'}),
            point?.earnedPointsChartData || []
          )}
        />
      </div>
      <div className='card px-5 min-w-400px w-100'>
        <RedeemedPoints
          total={digit(point?.redeemedPoints || 0)}
          data={dataToSeries(
            intl.formatMessage({id: 'ANALYTICS.REDEEMED_POINTS'}),
            point?.redeemedPointsChartData || []
          )}
        />
      </div>
    </div>
  )
}
